<template>
  <portal to="iqos-modal-portal">
    <div class="pop-up">
      <div v-if="title" class="title">{{ title }}</div>
      <img
        v-if="showCloseIcon"
        class="close"
        src="/icons/close-popup.svg"
        alt=""
        @click="$emit('close')"
      />
      <slot></slot>
    </div>
  </portal>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style scoped>
.pop-up {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(29, 29, 27, 0.7);
  backdrop-filter: blur(15px);
  z-index: 10;
}
.close {
  position: absolute;
  top: 2.2222vh;
  right: 2.2222vh;
  width: 5.555555555555555vh;
  height: 5.555555555555555vh;
}
.title {
  font-size: 4vh;
  line-height: 4.555555555555555vh;
  color: #ededed;
  padding: 4.444444444444445vh 5.555555555555555vh 1.1111111111111112vh;
}
</style>
